import { emptyFragment, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { enforcingConsentManager, showCookiePreferences } from '../../../Osano';
import { T } from '../../../Translations';
import Divider from '../Divider';

function CookiePreferencesLink() {
  return enforcingConsentManager()
    .map((cm) => (
      <>
        <Divider />
        <button
          type="button"
          className="cursor-pointer"
          data-testid="footer_cookie-preferences-link"
          data-intercom-target="footer-cookie-preferences-button"
          onClick={() => {
            showCookiePreferences(cm);
          }}
        >
          <Typography
            className="text-foreground underline hover:text-primary"
            variant="bodyMedium"
            fontWeight="semibold"
            as="span"
          >
            <T kind="Cookie preferences" />
          </Typography>
        </button>
      </>
    ))
    .getOrElse(emptyFragment);
}

export default observer(CookiePreferencesLink);
